import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navigation from './Navigation';
import { Dialog, DialogContent } from '@material-ui/core';
import Body from './HTMLRender';

class Toolbar extends Component {
    constructor(props){
        super(props);
        this.state = {
            open: false
        }
    }
    render(){
        return(
            <div className="flex-box flex-between nav-buttons">
                {this.props.activeScene.sidebar ? (<button onClick={()=>this.setState({open: true})}><img  className="animate-float icon" src="https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/organizational/post-it.svg"  alt="learn more"/></button>):(<div>&nbsp;</div>)}
                <Navigation history={this.props.history}/>
                <Dialog className="dialog-pop" open={this.state.open} onClose={()=>this.setState({open: false})}>
    
                    <DialogContent>
                        <div className="dialog-body">
                            {this.props.activeScene.sidebarText.length > 0 && this.props.activeScene.sidebarText.map((item, i) => {
                                return ( <Body text={item} key={i}/>);
                            })}
                            </div>
                            <div className="flex-box flex-end ">
                            <button onClick={()=>this.setState({open: false})} className="button">close</button>
                            </div>
                     
                    </DialogContent>
                </Dialog>
                </div>
        );
    }
}
const mapStateToProps = state => ({
    activeScene: state.activeScene
})
export default connect(mapStateToProps)(Toolbar);